import { createRouter, createWebHistory } from "vue-router";
import store from '@/store';
import Layout from '@/Layout/index.vue';

function guard(to, from, next) {
  if (localStorage.activeUser) {
    next();
  } else next({ name: "Login" });
}

const routes = [
  {
    path: "/",
    name: "Login",
    component: () => import("@/views/auth/login/index.vue"),
    meta: {
      titles: {
        en: "Login",
        ru: "Вход",
        kz: "Кіру"
      }
    }
  },
  {
    path: "/tracker",
    name: "Login Tracker",
    component: () => import("@/views/time-tracker/login/index.vue"),
    meta: {
      titles: {
        en: "Login Tracker",
        ru: "Вход Tracker",
        kz: "Кіру Tracker"
      }
    }
  },
  {
    path: "/time-tracker",
    name: "Time Tracker Page",
    component: () => import("@/views/time-tracker"),
  },
  {
    path: "/register",
    name: "reg",
    component: () => import("@/views/auth/register"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/auth/forgot-password.vue"),
  },
  {
    path: "/forgot-password2",
    name: "forgot-password2",
    component: () => import("@/views/auth/forgot-password2.vue"),
  },
  {
    path: "/forgot-password3",
    name: "forgot-password3",
    component: () => import("@/views/auth/forgot-password3.vue"),
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: () => import("@/views/auth/lock-screen.vue"),
  },
  {
    path: "/lock-screen2",
    name: "lock-screen2",
    component: () => import("@/views/auth/lock-screen2.vue"),
  },
  {
    path: "/lock-screen3",
    name: "lock-screen3",
    component: () => import("@/views/auth/lock-screen3.vue"),
  },
  {
    path: "/success-500",
    name: "success-500",
    component: () => import("@/views/auth/success.vue"),
  },
  {
    path: "/app",
    name: "Layout",
    redirect: "/app/home",
    component: () => import("@/Layout/index.vue"),
    beforeEnter: guard,
    children: [      
      {
        path: "blank-page",
        name: "blank-page",
        component: () => import("@/views/blank-page.vue"),
      },
      {
        path: "notifications",
        name: "notifications",
        component: () => import("@/views/notifications.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "home",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "ecommerce",
        name: "ecommerce",
        component: () => import("@/views/home/ecommerce.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "banking",
        name: "banking",
        component: () => import("@/views/home/banking.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "crm",
        name: "crm",
        component: () => import("@/views/home/crm.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "project",
        name: "project",
        component: () => import("@/views/home/project.vue"),
        meta: {
          hide: true,
        },
      },

      // components
      {
        path: "button",
        name: "button",
        component: () => import("@/views/components/button/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "alert",
        name: "alert",
        component: () => import("@/views/components/alert/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "card",
        name: "card",
        component: () => import("@/views/components/card/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "carousel",
        name: "carousel",
        component: () => import("@/views/components/carousel.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "dropdown",
        name: "dropdown",
        component: () => import("@/views/components/dropdown/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "modal",
        name: "dodal",
        component: () => import("@/views/components/modal/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "tab-accordion",
        name: "tab-accordion",
        component: () => import("@/views/components/tab-accordion/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "badges",
        name: "badges",
        component: () => import("@/views/components/badges.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "tooltip-popover",
        name: "tooltip-popover",
        component: () => import("@/views/components/tooltip-popover.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "typography",
        name: "typography",
        component: () => import("@/views/components/typography.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'typography/timesheet',
        name: 'typography-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/typography/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'accounting/timesheet',
        name: 'accounting-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/accounting/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'accounting_manager/timesheet',
        name: 'accounting-timesheet-bridge manager',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/accounting_manager/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'executor/timesheet',
        name: 'executor-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/executor/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'project-manager/timesheet',
        name: 'project-manager-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/project-manager/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'stock/timesheet',
        name: 'stock-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/stock/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'supervisor/timesheet',
        name: 'supervisor-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/users/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/supervisor/home' });
          }
        },
      },
      {
        // промежуточная точка входа из меню / апи
        path: 'typo/timesheet',
        name: 'typo-timesheet-bridge',
        beforeEnter: (to, from, next) => {
          // 1) пробуем взять из query (?id=123)
          let id = to.query?.id;

          // 2) если нет — берём текущего пользователя
          if (!id) {
            const activeUser = JSON.parse(localStorage.getItem('activeUser') || '{}');
            id = activeUser?.id;
          }

          if (id) {
            // сразу переходим на детальную
            next({ path: `/time-tracker/typo/${id}` });
          } else {
            // запасной вариант
            next({ path: '/app/typo/home' });
          }
        },
      },
      {
        path: "colors",
        name: "colors",
        component: () => import("@/views/components/colors.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "image",
        name: "image",
        component: () => import("@/views/components/image/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "video",
        name: "video",
        component: () => import("@/views/components/video.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "pagination",
        name: "pagination",
        component: () => import("@/views/components/pagination"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "progress-bar",
        name: "progress-bar",
        component: () => import("@/views/components/progress-bar/index.vue"),
        meta: {
          groupParent: "components",
        },
      },
      {
        path: "placeholder",
        name: "placeholder",
        component: () => import("@/views/components/placeholder.vue"),
        meta: {
          groupParent: "placeholder",
        },
      },
      // widgets
      {
        path: "basic",
        name: "basic",
        component: () => import("@/views/widgets/basic.vue"),
        meta: {
          groupParent: "widgets",
        },
      },
      {
        path: "statistic",
        name: "statistic",
        component: () => import("@/views/widgets/statistic.vue"),
        meta: {
          groupParent: "widgets",
        },
      },

      // forms
      {
        path: "input",
        name: "input",
        component: () => import("@/views/forms/input"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "input-group",
        name: "input-group",
        component: () => import("@/views/forms/input-group"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "input-layout",
        name: "input-layout",
        component: () => import("@/views/forms/input-layout"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "form-validation",
        name: "form-validation",
        component: () => import("@/views/forms/form-validation"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "form-wizard",
        name: "form-wizard",
        component: () => import("@/views/forms/form-wizard"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "form-repeater",
        name: "form-repeater",
        component: () => import("@/views/forms/form-repeater"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "input-mask",
        name: "input-mask",
        component: () => import("@/views/forms/input-mask"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "file-input",
        name: "file-input",
        component: () => import("@/views/forms/file-input"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "checkbox",
        name: "checkbox",
        component: () => import("@/views/forms/checkbox.vue"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "radio-button",
        name: "radio-button",
        component: () => import("@/views/forms/radio-button.vue"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "textarea",
        name: "textarea",
        component: () => import("@/views/forms/textarea"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "switch",
        name: "switch",
        component: () => import("@/views/forms/switch"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "select",
        name: "select",
        component: () => import("@/views/forms/select"),
        meta: {
          groupParent: "forms",
        },
      },
      {
        path: "date-time-picker",
        name: "date-time-picker",
        component: () => import("@/views/forms/date-time-picker"),
        meta: {
          groupParent: "forms",
        },
      },
      // table view
      {
        path: "table-basic",
        name: "table-basic",
        component: () => import("@/views/table/basic"),
        meta: {
          groupParent: "Table",
        },
      },
      {
        path: "table-advanced",
        name: "table-advanced",
        component: () => import("@/views/table/advanced"),
        meta: {
          groupParent: "Table",
        },
      },
      // chart
      {
        path: "appex-chart",
        name: "appex-chart",
        component: () => import("@/views/chart/appex-chart"),
        meta: {
          groupParent: "charts",
        },
      },
      {
        path: "chartjs",
        name: "chartjs",
        component: () => import("@/views/chart/chartjs"),
        meta: {
          groupParent: "charts",
        },
      },
      // app
      {
        path: "calender",
        name: "calender",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "todo",
        name: "todo",
        component: () => import("@/views/app/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "kanban",
        name: "kanban",
        component: () => import("@/views/app/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "email",
        name: "email",
        component: () => import("@/views/app/email"),
        meta: {
          groupParent: "Project",
          hide: true,
          appheight: true,
        },
      },
      {
        path: "initiator/home",
        name: "inithome",
        component: () => import("@/views/initiator/home"),
      },
      {
        path: "initiator/support",
        name: "initsupport",
        component: () => import("@/views/support/Support.vue"),
      },
      {
        path: "deputy/support",
        name: "deputysupport",
        component: () => import("@/views/support/SupportDashboard.vue"),
      },
      {
        path: "initiator/techcards",
        name: "Техкарты Инициатор",
        component: () => import("@/views/initiator/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/techcards",
        name: "Техкарты SE",
        component: () => import("@/views/science_editor/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/offers",
        name: "initiatorOffers",
        component: () => import("@/views/initiator/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.initiatorOffers",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/offers",
        name: "SE Offers",
        component: () => import("@/views/science_editor/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.initiatorOffers",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/chat",
        name: "initiatorChat",
        component: () => import("@/views/initiator/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "stock/chat",
        name: "stockChat",
        component: () => import("@/views/stock/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.stock",
        },
      },
      {
        path: "accounting/statistics",
        name: "ecommerce",
        component: () => import("@/views/accounting/ecommerce"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/contracts",
        name: "contracts",
        component: () => import("@/views/accounting/contracts"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/contracts",
        name: "contracts AM",
        component: () => import("@/views/accounting_manager/contracts"),
        meta: {
          hide: true,
        },
      },
      {
        path: "hr/contracts",
        name: "HR contracts",
        component: () => import("@/views/hr/contracts"),
        meta: {
          hide: true,
        },
      },
      {
        path: "hr/contract-add/personal",
        name: "HR contract-add(Personal)",
        component: () => import("@/views/hr/contracts/contract-add-personal"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "hr/contract-add/confidence",
        name: "HR contract-add(Confidence)",
        component: () => import("@/views/hr/contracts/contract-add-confidence"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "hr/contract-add/itd",
        name: "HR contract-add(ITD)",
        component: () => import("@/views/hr/contracts/contract-add-itd"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "hr/contract-add/neconc",
        name: "HR contract-add(Neconc)",
        component: () => import("@/views/hr/contracts/contract-add-neconc"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "hr/contract-add/gph",
        name: "HR contract-add(GPH)",
        component: () => import("@/views/hr/contracts/contract-add-gph"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "supervisor/contracts",
        name: "SU contracts",
        component: () => import("@/views/supervisor/contracts"),
        meta: {
          hide: true,
        },
      },
      {
        path: "supervisor/contracts/hr",
        name: "SU contracts HR",
        component: () => import("@/views/supervisor/contracts/hr"),
        meta: { hide: true },
      },
      {
        path: "supervisor/contracts/op",
        name: "SU contracts OP",
        component: () => import("@/views/supervisor/contracts/op"),
        meta: { hide: true },
      },
      {
        path: "supervisor/contracts/biz",
        name: "SU contracts BIZ",
        component: () => import("@/views/supervisor/contracts/biz"),
        meta: { hide: true },
      },
      {
        path: "author/contracts",
        name: "Author contracts",
        component: () => import("@/views/author/contracts"),
        meta: {
          hide: true,
        },
      },
      {
        path: "executor/contracts",
        name: "Executor contracts",
        component: () => import("@/views/executor/contracts"),
        meta: {
          hide: true,
        },
      },
       {
        path: "project-manager/contracts",
        name: "PM contracts",
        component: () => import("@/views/project-manager/contracts"),
        meta: {
          hide: true,
        },
      },
       {
        path: "partner/contracts",
        name: "Partner contracts",
        component: () => import("@/views/partner/contracts"),
        meta: {
          hide: true,
        },
      },
      // { path: '/app/accounting/contracts/create', name: 'contractCreate', component: ContractForm },
       {
        path: "supervisor/statistics",
        name: "ecommerce SU",
        component: () => import("@/views/supervisor/ecommerce"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/chat",
        name: "accountingChat",
        component: () => import("@/views/accounting/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/chat",
        name: "accountingChat manager",
        component: () => import("@/views/accounting_manager/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "partner/chat",
        name: "partnerChat",
        component: () => import("@/views/partner/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.partner",
        },
      },
      {
        path: "typography/chat",
        name: "typographyChat",
        component: () => import("@/views/typography/chat"),
        meta: {
          hide: true,
          appheight: true,
          titleKey: "breadcrumb.initiatorChat",
          groupParent: "breadcrumb.typography",
        },
      },
      {
        path: "initiator/booktracking",
        name: "bookTrackingInitiator",
        component: () => import("@/views/initiator/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/booktracking",
        name: "bookTracking SE",
        component: () => import("@/views/science_editor/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/kanban",
        name: "kanbanInitiator",
        component: () => import("@/views/initiator/kanban"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kanbanInitiator",
          groupParent: "breadcrumb.initiator",
        },
      },
       {
        path: "science_editor/kanban",
        name: "kanbanSE",
        component: () => import("@/views/science_editor/kanban"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kanbanInitiator",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/calendar",
        name: "Calender Initiator",
        component: () => import("@/views/project-manager/calendar"),
      },
      {
        path: "initiator/applications",
        name: "Заявки авторов",
        component: () => import("@/views/initiator/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/applications",
        name: "Заявки авторов Университет",
        component: () => import("@/views/science_editor/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "department_reviewer/applications",
        name: "Заявки авторов Университет DR",
        component: () => import("@/views/department_reviewer/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "institute_reviewer/applications",
        name: "Заявки авторов Университет IR",
        component: () => import("@/views/institute_reviewer/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "library_reviewer/applications",
        name: "Заявки авторов Университет LR",
        component: () => import("@/views/library_reviewer/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/applications/grid",
        name: "Init applications-grid",
        component: () => import("@/views/initiator/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "science_editor/applications/grid",
        name: "SE applications-grid",
        component: () => import("@/views/science_editor/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "department_reviewer/applications/grid",
        name: "DR applications-grid",
        component: () => import("@/views/department_reviewer/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "ac_member/applications/grid",
        name: "AC member applications-grid",
        component: () => import("@/views/ac_member/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "ums_member/applications/grid",
        name: "UMS member applications-grid",
        component: () => import("@/views/ums_member/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "rums_member/applications/grid",
        name: "RUMS member applications-grid",
        component: () => import("@/views/rums_member/applications/ApplicationsGridPage.vue"),
      },
       {
        path: "riso_member/applications/grid",
        name: "RISO member applications-grid",
        component: () => import("@/views/riso_member/applications/ApplicationsGridPage.vue"),
      },
       {
        path: "institute_reviewer/applications/grid",
        name: "IR applications-grid",
        component: () => import("@/views/institute_reviewer/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "library_reviewer/applications/grid",
        name: "LR applications-grid",
        component: () => import("@/views/library_reviewer/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "initiator/appstatus",
        name: "Статус заявки",
        component: () => import("@/views/initiator/applications/ChangeStatus.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "department_reviewer/appstatus",
        name: "Статус заявки DR",
        component: () => import("@/views/department_reviewer/applications/ChangeStatus.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "institute_reviewer/appstatus",
        name: "Статус заявки IR",
        component: () => import("@/views/institute_reviewer/applications/ChangeStatus.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "library_reviewer/appstatus",
        name: "Статус заявки LR",
        component: () => import("@/views/library_reviewer/applications/ChangeStatus.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "initiator/application-details",
        name: "Страница заявки",
        component: () => import("@/views/initiator/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "department_reviewer/application-details",
        name: "Страница заявки DR",
        component: () => import("@/views/department_reviewer/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
       {
        path: "institute_reviewer/application-details",
        name: "Страница заявки IR",
        component: () => import("@/views/institute_reviewer/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "library_reviewer/application-details",
        name: "Страница заявки LR",
        component: () => import("@/views/library_reviewer/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "science_editor/application-details",
        name: "Страница заявки SE",
        component: () => import("@/views/science_editor/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "author/calendar",
        name: "Calender Author",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "author/home",
        name: "authorhome",
        component: () => import("@/views/author/home"),
        meta: {
          titles: {
            en: "Author Home",
            ru: "Главная страница",
            kz: "Басты бет"
          }
        }
      },
      {
        path: "author/chat",
        name: "Author chat",
        component: () => import("@/views/author/chat"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "author/kanban",
        name: "Kanban author",
        component: () => import("@/views/author/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "author/applications",
        name: "applications",
        component: () => import("@/views/author/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "/applications/grid",
        name: "applications-grid",
        component: () => import("@/views/author/applications/ApplicationsGridPage.vue"),
      },
      {
        path: "author/reviews",
        name: "reviews",
        component: () => import("@/views/author/reviews"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.author",
        },
      },
       {
        path: "expert/reviews",
        name: "Expert reviews",
        component: () => import("@/views/expert/reviews"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.author",
        },
      },
       {
        path: "reviewer/reviews",
        name: "Reviewer reviews",
        component: () => import("@/views/reviewer/reviews"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "author/application-details",
        name: "application-details",
        component: () => import("@/views/author/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "/author/application-standards",
        name: "application-standards",
        component: () => import("@/views/author/applications/ApplicationStandards.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "author/nonacadem-application-details",
        name: "application-details-nonacademic",
        component: () => import("@/views/author/applications/nonacadem-application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: 'author/profile/:id',
        name: 'author-profile',
        component: () => import("@/views/author/profile"),
        meta: {
          hide: true,
        },
      },
      {
        path: 'author/profile-setting',
        name: 'Author Profile Setting',
        component: () => import("@/views/author/profile/profile-setting.vue"),
      },
      {
        path: 'partner/profile/:id',
        name: 'partner-profile',
        component: () => import("@/views/partner/profile"),
        meta: {
          hide: true,
        },
      },
      {
        path: 'partner/profile-setting',
        name: 'Partner Profile Setting',
        component: () => import("@/views/partner/profile/profile-setting.vue"),
      },
      {
        path: "author/offers",
        name: "authoroffers",
        component: () => import("@/views/author/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offers",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "author/invoice-preview",
        name: "InvoicePreview Author",
        component: () => import("@/views/author/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "author/invoice-preview",
        name: "KPPreview Author",
        component: () => import("@/views/author/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "initiator/invoice-preview",
        name: "InvoicePreview Init",
        component: () => import("@/views/initiator/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/invoice-preview",
        name: "KPPreview Init",
        component: () => import("@/views/initiator/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "project-manager/invoice-preview",
        name: "InvoicePreview PM",
        component: () => import("@/views/project-manager/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "project-manager/invoice-preview",
        name: "KPPreview PM",
        component: () => import("@/views/project-manager/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.projectManager",
        },
      },
       {
        path: "project-manager/invoice-preview",
        name: "KPPreview PM Kanban",
        component: () => import("@/views/project-manager/kanban/column/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "author/booktracking",
        name: "BookTracking author",
        component: () => import("@/views/author/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.author",
        },
      },
      {
        path: "executor/home",
        name: "executorhome",
        component: () => import("@/views/executor/home"),
      },
      {
        path: "executor/kanban",
        name: "Kanban executor",
        component: () => import("@/views/executor/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "executor/todo",
        name: "Задачи Исполнитель",
        component: () => import("@/views/executor/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "executor/chat",
        name: "Executor chat",
        component: () => import("@/views/executor/chat"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "executor/calendar",
        name: "Calender Executor",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "executor/projects",
        name: "Новые проекты",
        component: () => import("@/views/executor/projects"),
        meta: {
          hide: true,
        },
      },
      {
        path: "executor/project-details",
        name: "Страница проекта(Исполнитель)",
        component: () => import("@/views/executor/projects/project-details.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "project-manager/home",
        name: "project-managerhome",
        component: () => import("@/views/project-manager/home"),
      },
      {
        path: "project-manager/offers",
        name: "Мои документы(project-manager)",
        component: () => import("@/views/project-manager/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offers",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "project-manager/chat",
        name: "Project-manager chat",
        component: () => import("@/views/project-manager/chat"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "project-manager/calendar",
        name: "Calender PM",
        component: () => import("@/views/project-manager/calendar"),
      },
      {
        path: "project-manager/kanban",
        name: "Kanban PM",
        component: () => import("@/views/project-manager/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "project-manager/todo",
        name: "Задачи",
        component: () => import("@/views/project-manager/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "project-manager/projects",
        name: "projectsPM",
        component: () => import("@/views/project-manager/projects"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.projectsPM",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "project-manager/project-details",
        name: "Страница проекта",
        component: () => import("@/views/project-manager/projects/project-details.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "project-manager/techcards",
        name: "pmtechCards",
        component: () => import("@/views/project-manager/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "executor/techcards",
        name: "extechCards",
        component: () => import("@/views/executor/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.executor",
        },
      },
      {
        path: "project-manager/booktracking",
        name: "BookTrackingPM",
        component: () => import("@/views/project-manager/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "project-manager/mywallet",
        name: "My wallet PM",
        component: () => import("@/views/project-manager/projects/MyWallet.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: 'project-manager/myrating',
        name: 'My Rating PM',
        component: () => import('@/views/project-manager/projects/MyRating.vue'),
        meta: {
          hide: true,
        },
      },
      {
        path: "executor/mywallet",
        name: "My wallet Executor",
        component: () => import("@/views/executor/projects/MyWallet.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.executor",
        },
      },
       {
        path: 'executor/myrating',
        name: 'My Rating Executor',
        component: () => import('@/views/executor/projects/MyRating.vue'),
        meta: {
          hide: true,
        },
      },
      {
        path: "/executor/executor-bonuses",
        name: "executor-bonuses",
        component: () => import("@/views/executor/projects/MyBonus.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "/typography/bonuses",
        name: "typography-bonuses",
        component: () => import("@/views/typography/chat/MyBonus.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "/accounting_manager/bonuses",
        name: "sales-bonuses",
        component: () => import("@/views/accounting_manager/chat/MyBonus.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "/project-manager/bonuses",
        name: "project-manager-bonuses",
        component: () => import("@/views/project-manager/projects/MyBonus.vue"),
      },
      {
        path: "/author/bonuses",
        name: "author-bonuses",
        component: () => import("@/views/author/profile/MyBonus.vue"),
      },
      {
        path: "typography/kanban",
        name: "Kanban Typography",
        component: () => import("@/views/typography/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "typography/calendar",
        name: "Calender Typography",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "typography/techcards",
        name: "Техкарты Typography",
        component: () => import("@/views/typography/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.typography",
        },
      },
      {
        path: "typography/booktracking",
        name: "BookTrackingTypography",
        component: () => import("@/views/typography/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.typography",
        },
      },
      {
        path: "typography/invoice-preview/:id",
        name: "TechCardPreview Typography",
        component: () => import("@/views/typography/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.typography",
        },
      },
      {
        path: "accounting/home",
        name: "accountinghome",
        component: () => import("@/views/accounting/home"),
      },
      {
        path: "accounting_manager/home",
        name: "accountingmanagerhome",
        component: () => import("@/views/accounting_manager/home"),
      },
      {
        path: "partner/home",
        name: "partnerhome",
        component: () => import("@/views/partner/home"),
      },
      {
        path: "accounting/todo",
        name: "Задачи Accounting",
        component: () => import("@/views/accounting/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "accounting_manager/todo",
        name: "Задачи Accounting Manager",
        component: () => import("@/views/accounting_manager/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "project-manager/tasks",
        name: "Задачи PM",
        component: () => import("@/views/project-manager/tasks"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "partner/todo",
        name: "Задачи Partner",
        component: () => import("@/views/partner/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "accounting/kanban",
        name: "Accounting Kanban",
        component: () => import("@/views/accounting/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/kanban",
        name: "Accounting Manager Kanban",
        component: () => import("@/views/accounting_manager/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/partnerKanban",
        name: "Accounting Kanban TP",
        component: () => import("@/views/accounting/partnerKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/partnerKanban",
        name: "Accounting Manager Kanban TP",
        component: () => import("@/views/accounting_manager/partnerKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/smartKanban",
        name: "Accounting Kanban TP Smart",
        component: () => import("@/views/accounting/smartKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/smartKanban",
        name: "Accounting Manager Kanban TP Smart",
        component: () => import("@/views/accounting_manager/smartKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/ibpKanban",
        name: "Accounting Kanban IBP",
        component: () => import("@/views/accounting/ibpKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/ibpKanban",
        name: "Accounting Manager Kanban IBP",
        component: () => import("@/views/accounting_manager/ibpKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "typography/ibpKanban",
        name: "Typography Kanban IBP",
        component: () => import("@/views/typography/ibpKanban"),
        meta: {
          hide: true,
        },
      },
       {
        path: "supervisor/todo",
        name: "Задачи SU",
        component: () => import("@/views/supervisor/todo"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "supervisor/meeting",
        name: "Собрание SU",
        component: () => import("@/views/supervisor/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "riso_secretary/meeting",
        name: "Собрание RISO",
        component: () => import("@/views/riso_secretary/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "ac_secretary/meeting",
        name: "Собрание AC",
        component: () => import("@/views/ac_secretary/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "ums_secretary/meeting",
        name: "Собрание УМС",
        component: () => import("@/views/ums_secretary/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "rums_secretary/meeting",
        name: "Собрание РУМС",
        component: () => import("@/views/rums_secretary/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "ums_member/meeting",
        name: "Собрание члена UMS",
        component: () => import("@/views/ums_member/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
       {
        path: "rums_member/meeting",
        name: "Собрание члена RUMS",
        component: () => import("@/views/rums_member/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
       {
        path: "riso_secretary/applications",
        name: "applications riso",
        component: () => import("@/views/riso_secretary/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "ac_secretary/applications",
        name: "applications ac",
        component: () => import("@/views/ac_secretary/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "ums_secretary/applications",
        name: "applications ums",
        component: () => import("@/views/ums_secretary/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "rums_secretary/applications",
        name: "applications rums",
        component: () => import("@/views/rums_secretary/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "ac_member/applications",
        name: "applications члена УС",
        component: () => import("@/views/ac_member/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "ums_member/applications",
        name: "applications члена UMS",
        component: () => import("@/views/ums_member/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
       {
        path: "rums_member/applications",
        name: "applications члена RUMS",
        component: () => import("@/views/rums_member/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
      {
        path: "riso_member/applications",
        name: "applications члена RISO",
        component: () => import("@/views/riso_member/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.riso",
        },
      },
       {
        path: "riso_secretary/application-details",
        name: "application-details Riso",
        component: () => import("@/views/riso_secretary/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "ac_secretary/application-details",
        name: "application-details AC",
        component: () => import("@/views/ac_secretary/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
       {
        path: "ums_secretary/application-details",
        name: "application-details UMS",
        component: () => import("@/views/ums_secretary/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
       {
        path: "riso_member/application-details",
        name: "application-details члена RISO",
        component: () => import("@/views/riso_member/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "ac_member/application-details",
        name: "application-details члена УС",
        component: () => import("@/views/ac_member/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "ums_member/application-details",
        name: "application-details члена UMS",
        component: () => import("@/views/ums_member/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "riso_member/meeting",
        name: "Собрание RISO-member",
        component: () => import("@/views/riso_member/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      
       {
        path: "project-manager/meeting",
        name: "Собрание PM",
        component: () => import("@/views/project-manager/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "accounting/meeting",
        name: "Собрание OP",
        component: () => import("@/views/accounting/meeting"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "supervisor/partnerKanban",
        name: "Superuser Kanban TP",
        component: () => import("@/views/supervisor/partnerKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "supervisor/smartKanban",
        name: "Superuser Kanban TP Smart",
        component: () => import("@/views/supervisor/smartKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "typography/partnerKanban",
        name: "Typography Kanban TP",
        component: () => import("@/views/typography/partnerKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "typography/smartKanban",
        name: "Typography Kanban TP Smart",
        component: () => import("@/views/typography/smartKanban"),
        meta: {
          hide: true,
        },
      },
       {
        path: "typography/orderKanban",
        name: "Typography Kanban Eshop",
        component: () => import("@/views/typography/eshopKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting/orderKanban",
        name: "Accounting Kanban Eshop",
        component: () => import("@/views/accounting/eshopKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "accounting_manager/orderKanban",
        name: "Accounting Manager Kanban Eshop",
        component: () => import("@/views/accounting_manager/eshopKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "partner/orderKanban",
        name: "Partner Kanban Eshop",
        component: () => import("@/views/partner/eshopKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "science_editor/orderKanban",
        name: "SE Kanban Eshop",
        component: () => import("@/views/science_editor/eshopKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "stock/partnerKanban",
        name: "Stock Kanban TP",
        component: () => import("@/views/stock/partnerKanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "stock/smartKanban",
        name: "Stock Kanban TP Smart",
        component: () => import("@/views/stock/smartKanban"),
        meta: {
          hide: true,
        },
      },
      
      {
        path: "partner/kanban",
        name: "Partner Kanban",
        component: () => import("@/views/partner/kanban"),
        meta: {
          hide: true,
        },
      },
       {
        path: "partner/kanbanPress",
        name: "Partner Kanban Press",
        component: () => import("@/views/partner/kanbanPress"),
        meta: {
          hide: true,
        },
      },
      {
        path: "stock/kanban",
        name: "Stock Kanban",
        component: () => import("@/views/stock/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "stock/booktracking",
        name: "BookTrackingStock",
        component: () => import("@/views/stock/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.stock",
        },
      },
      {
        path: "accounting/calendar",
        name: "Calender accounting",
        component: () => import("@/views/accounting/calendar"),
      },
      {
        path: "accounting_manager/calendar",
        name: "Calender accounting manager",
        component: () => import("@/views/accounting_manager/calendar"),
      },
      {
        path: "partner/calendar",
        name: "Calender Partner",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "stock/calendar",
        name: "Calender stock",
        component: () => import("@/views/author/calendar"),
      },
      {
        path: "accounting/techcards",
        name: "Техкарты accounting",
        component: () => import("@/views/accounting/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/techcards",
        name: "Техкарты accounting manager",
        component: () => import("@/views/accounting_manager/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting/books",
        name: "Books accounting",
        component: () => import("@/views/accounting/books"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/books",
        name: "Books accounting manager",
        component: () => import("@/views/accounting_manager/books"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "supervisor/books",
        name: "Books SU",
        component: () => import("@/views/supervisor/books"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.superuser",
        },
      },
       {
        path: "author/wallet",
        name: "Books author",
        component: () => import("@/views/author/wallet"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.author",
        },
      },
       {
        path: "accounting/royalty",
        name: "Royalty accounting",
        component: () => import("@/views/accounting/royalty"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.accounting",
        },
      },
       {
        path: "accounting_manager/royalty",
        name: "Royalty accounting manager",
        component: () => import("@/views/accounting_manager/royalty"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "project-manager/books",
        name: "Books PM",
        component: () => import("@/views/project-manager/books"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.books",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "stock/techcards",
        name: "Техкарты stock",
        component: () => import("@/views/stock/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.stock",
        },
      },
      {
        path: "accounting/invoice-preview/:id",
        name: "TechCardPreview",
        component: () => import("@/views/accounting/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/invoice-preview/:id",
        name: "TechCardPreview AM",
        component: () => import("@/views/accounting_manager/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.accounting",
        },
      },

      {
        path: "supervisor/invoice-preview/:id",
        name: "TechCardPreview SU",
        component: () => import("@/views/supervisor/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/chat",
        name: "Super-user chat",
        component: () => import("@/views/supervisor/chat"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      {
        path: "supervisor/applications",
        name: "Заявки авторов SU",
        component: () => import("@/views/supervisor/applications"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.applications",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/home",
        name: "suhome",
        component: () => import("@/views/supervisor/home"),
      },
      {
        path: "supervisor/application-details",
        name: "Страница заявки SU",
        component: () => import("@/views/supervisor/applications/application-details.vue"), // Adjusted import path
        meta: {
          hide: true,
        },
      },
      {
        path: "supervisor/projects",
        name: "projectsSU",
        component: () => import("@/views/supervisor/projects"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.projectsPM",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/users",
        name: "users",
        component: () => import("@/views/supervisor/users"),
        meta: {
          hide: true,
          titleKey: "Users",
          groupParent: "breadcrumb.superuser",
        },
      },
       {
        path: "hr/users",
        name: "users HR",
        component: () => import("@/views/hr/users"),
        meta: {
          hide: true,
          titleKey: "Users",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: '/app/hr/wallets/:id',
        name: 'hr-wallets-user',
        component: () => import('@/views/hr/users/MyWallet.vue'),
      },
       {
        path: "hr/userdocs",
        name: "users HR Docs",
        component: () => import("@/views/hr/userdocs"),
        meta: {
          hide: true,
          titleKey: "Users",
          groupParent: "breadcrumb.superuser",
        },
      },
       {
        path: "hr/timesheet",
        name: "Timesheet HR",
        component: () => import("@/views/hr/timesheet"),
        meta: {
          hide: true,
          titleKey: "Timesheet",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: '/time-tracker/users/:id',
        name: 'tt-user-details',
        component: () => import('@/views/hr/users/user-details.vue'),
      },
      {
        path: '/time-tracker/typo/:id',
        name: 'tt-users-details',
        component: () => import('@/views/typo/users/user-details.vue'),
      },
       {
        path: "supervisor/organizations",
        name: "organizations",
        component: () => import("@/views/supervisor/organizations"),
        meta: {
          hide: true,
          titleKey: "Organizations",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/project-details",
        name: "Страница проекта SU",
        component: () => import("@/views/supervisor/projects/project-details.vue"),
        meta: {
          hide: true,
        },
      },
      {
        path: "project-manager/invoice-preview/:id",
        name: "TechCardPreview PM",
        component: () => import("@/views/project-manager/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.projectManager",
        },
      },
      {
        path: "initiator/invoice-preview/:id",
        name: "TechCardPreview INIT",
        component: () => import("@/views/initiator/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/invoice-preview/:id",
        name: "TechCardPreview SE",
        component: () => import("@/views/science_editor/techcards/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.techCardPreviewInit",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "initiator/users",
        name: "users Initiator",
        component: () => import("@/views/initiator/users"),
        meta: {
          hide: true,
          titleKey: "Users",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "science_editor/users",
        name: "users SE",
        component: () => import("@/views/science_editor/users"),
        meta: {
          hide: true,
          titleKey: "Users",
          groupParent: "breadcrumb.initiator",
        },
      },
      {
        path: "accounting/invoice",
        name: "Accounting invoice",
        component: () => import("@/views/accounting/invoice"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting_manager/invoice",
        name: "Accounting Manager invoice",
        component: () => import("@/views/accounting_manager/invoice"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "partner/invoice",
        name: "Partner invoice",
        component: () => import("@/views/partner/invoice"),
        meta: {
          groupParent: "Utility",
        },
      },
     
      {
        path: "accounting_manager/contract-edit/:id",
        name: "Accounting Manager contract-edit",
        component: () => import("@/views/accounting_manager/contracts/contract-edit"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting/contract-add/author",
        name: "Accounting contract-add(Author)",
        component: () => import("@/views/accounting/contracts/contract-add-author"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting_manager/contract-add/author",
        name: "Accounting Manager contract-add(Author)",
        component: () => import("@/views/accounting_manager/contracts/contract-add-author"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "supervisor/contract-add/personal",
        name: "Supervisor contract-add(Personal)",
        component: () => import("@/views/supervisor/contracts/contract-add-personal"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "supervisor/contract-add/confidence",
        name: "Supervisor contract-add(Confidence)",
        component: () => import("@/views/supervisor/contracts/contract-add-confidence"),
        meta: {
          groupParent: "Utility",
        },
      },
      
      {
        path: "accounting/contract-add/realisation",
        name: "Accounting contract-add(realisation)",
        component: () => import("@/views/accounting/contracts/contract-add-realisation"),
        meta: {
          groupParent: "Utility",
        },
      },
       {
        path: "accounting_manager/contract-add/realisation",
        name: "Accounting Manager contract-add(realisation)",
        component: () => import("@/views/accounting_manager/contracts/contract-add-realisation"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting/contract-add/typography",
        name: "Accounting contract-add(Typography)",
        component: () => import("@/views/accounting/contracts/contract-add-typography"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting_manager/contract-add/typography",
        name: "Accounting Manager contract-add(Typography)",
        component: () => import("@/views/accounting_manager/contracts/contract-add-typography"),
        meta: {
          groupParent: "Utility",
        },
      },
       {
        path: "accounting/contract-add/memorandum",
        name: "Accounting contract-add(Memorandum)",
        component: () => import("@/views/accounting/contracts/contract-add-memorandum"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "accounting_manager/contract-add/memorandum",
        name: "Accounting Manager contract-add(Memorandum)",
        component: () => import("@/views/accounting_manager/contracts/contract-add-memorandum"),
        meta: {
          groupParent: "Utility",
        },
      },     
    
      {
        path: "accounting/offers",
        name: "offersAccounting",
        component: () => import("@/views/accounting/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
       {
        path: "accounting_manager/offers",
        name: "offersAccounting Manager",
        component: () => import("@/views/accounting_manager/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
       {
        path: "accounting/offers_archieve",
        name: "offersAccounting(Archieved)",
        component: () => import("@/views/accounting/offers_archieve"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/offers_archieve",
        name: "offersAccounting(Archieved) Manager",
        component: () => import("@/views/accounting_manager/offers_archieve"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting/offers_ibp",
        name: "offersIBPAccounting",
        component: () => import("@/views/accounting/offers_ibp"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/offers_ibp",
        name: "offersIBPAccounting Manager",
        component: () => import("@/views/accounting_manager/offers_ibp"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "partner/offers",
        name: "offersPartner",
        component: () => import("@/views/partner/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting/invoice-preview",
        name: "KPPreview Accounting",
        component: () => import("@/views/accounting/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/invoice-preview",
        name: "KPPreview Accounting Manager",
        component: () => import("@/views/accounting_manager/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: '/kp-preview-multi',
        name: 'KPPreviewMulti',
        component: () => import('@/views/accounting/offers/KPPreviewMulti.vue'),
      },
      {
        path: "accounting/invoice-preview",
        name: "KPPreview(IBP) Accounting",
        component: () => import("@/views/accounting/offers_ibp/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/invoice-preview",
        name: "KPPreview(IBP) Accounting Manager",
        component: () => import("@/views/accounting_manager/offers_ibp/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting/invoice-preview",
        name: "InvoicePreview",
        component: () => import("@/views/accounting/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting_manager/invoice-preview",
        name: "InvoicePreview AM",
        component: () => import("@/views/accounting_manager/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      {
        path: "accounting/invoice-preview",
        name: "InvoicePreview(IBP)",
        component: () => import("@/views/accounting/offers_ibp/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
       {
        path: "accounting_manager/invoice-preview",
        name: "InvoicePreview(IBP) AM",
        component: () => import("@/views/accounting_manager/offers_ibp/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.accounting",
        },
      },
      // {
      //   path: "partner/invoice-preview",
      //   name: "KPPreview partner",
      //   component: () => import("@/views/partner/offers/kp-preview.vue"),
      //   meta: {
      //     hide: true,
      //     titleKey: "breadcrumb.kpPreviewAuthor",
      //     groupParent: "breadcrumb.accounting",
      //   },
      // },
      // {
      //   path: "partner/invoice-preview",
      //   name: "InvoicePreview partner",
      //   component: () => import("@/views/partner/offers/invoice-preview.vue"),
      //   meta: {
      //     hide: true,
      //     titleKey: "breadcrumb.invoicePreviewAuthor",
      //     groupParent: "breadcrumb.accounting",
      //   },
      // },
      {
        path: "supervisor/techcards",
        name: "Техкарты supervisor" ,
        component: () => import("@/views/supervisor/techcards"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.techcards",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/invoice",
        name: "Superuser invoice",
        component: () => import("@/views/supervisor/invoice"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "supervisor/offers",
        name: "offersSU",
        component: () => import("@/views/supervisor/offers"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.offersAccount",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/invoice-preview",
        name: "KPPreview",
        component: () => import("@/views/supervisor/offers/kp-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.kpPreviewAuthor",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/invoice-preview",
        name: "InvoicePreview SU",
        component: () => import("@/views/supervisor/offers/invoice-preview.vue"),
        meta: {
          hide: true,
          titleKey: "breadcrumb.invoicePreviewAuthor",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/calendar",
        name: "Calender supervisor",
        component: () => import("@/views/supervisor/calendar"),
      },
      {
        path: "supervisor/booktracking",
        name: "BookTracking supervisor",
        component: () => import("@/views/supervisor/techcards/BookTracking.vue"), // Adjusted import path
        meta: {
          hide: true,
          titleKey: "breadcrumb.bookTrackingInitiator",
          groupParent: "breadcrumb.superuser",
        },
      },
      {
        path: "supervisor/kanban",
        name: "Kanban supervisor",
        component: () => import("@/views/supervisor/kanban"),
        meta: {
          hide: true,
        },
      },
      {
        path: "chat",
        name: "chat",
        component: () => import("@/views/app/chat"),
        meta: {
          hide: true,
          appheight: true,
        },
      },
      // normal pages
      {
        path: "invoice",
        name: "invoice",
        component: () => import("@/views/utility/invoice"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "invoice-preview",
        name: "invoice-preview",
        component: () => import("@/views/utility/invoice/invoice-preview"),
        meta: {
          hide: true,
        },
      },
      {
        path: "invoice-edit",
        name: "invoice-edit",
        component: () => import("@/views/utility/invoice/invoice-edit"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "invoice-add",
        name: "invoice-add",
        component: () => import("@/views/utility/invoice/invoice-add"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "Pricing",
        name: "pricing",
        component: () => import("@/views/utility/pricing"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "faq",
        name: "faq",
        component: () => import("@/views/utility/faq"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "blog",
        name: "blog",
        component: () => import("@/views/utility/blog"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "blog-details",
        name: "blog-details",
        component: () => import("@/views/utility/blog/blog-details"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "testimonial",
        name: "testimonial",
        component: () => import("@/views/utility/testimonial"),
        meta: {
          groupParent: "Utility",
        },
      },
      {
        path: "map",
        name: "map",
        component: () => import("@/views/map"),
      },
      {
        path: "profile/:id",
        name: "profile",
        component: () => import("@/views/profile.vue"),
      },
      {
        path: 'profile-setting',
        name: 'ProfileSetting',
        component: () => import("@/views/profile-setting.vue"),
      },
     
      {
        path: "settings",
        name: "settings",
        component: () => import("@/views/settings.vue"),
      },
      {
        path: "icons",
        name: "icons",
        component: () => import("@/views/icons.vue"),
      },
    ],
  },
  {
    path: "/:catchAll(.*)",
    name: "404",
    component: () => import("@/views/404.vue"),
  },
  {
    path: "/coming-soon",
    name: "coming-soon",
    component: () => import("@/views/utility/comming-soon"),
  },
  {
    path: "/under-construction",
    name: "under-construction",
    component: () => import("@/views/utility/under-construction"),
  },
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  const titleText = to.name;
  const words = titleText.split(" ");
  const wordslength = words.length;
  for (let i = 0; i < wordslength; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
  }

  document.title = "Smart University Press  - " + words;
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
